import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZoneRegionQuickInfo extends Layout {
    buttonZoneRegionCode: Button;
    panelZoneRegionQuickInfo: Panel;
    sourceZoneRegion: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxZoneSuperRegionId: Textbox;
}
